
import React from 'react';
import { createPortal } from 'react-dom';
import ReliableBottomNav from '../ReliableBottomNav';
import FloatingActionButton from '../FloatingActionButton';

const FixedElements: React.FC = () => {
  // Create portals to render directly to document body
  const bottomNavPortal = createPortal(
    <ReliableBottomNav />,
    document.body
  );

  const fabPortal = createPortal(
    <FloatingActionButton />,
    document.body
  );

  return (
    <>
      {bottomNavPortal}
      {fabPortal}
    </>
  );
};

export default FixedElements;
